(function(){
'use strict';
var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var hasGsap = typeof gsap !== 'undefined';
/* ScrollTrigger is a separate file — guard it independently so a partial CDN
   failure can never take the whole script (and the .rv reveals) down */
var hasST = hasGsap && typeof ScrollTrigger !== 'undefined';
var fine = window.matchMedia('(pointer:fine)').matches;

/* ---------- reveal (runs first: must survive any downstream failure) ---------- */
(function(){
  var els = document.querySelectorAll('.rv');
  if (!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-in')}); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if (en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, {threshold:.18});
  els.forEach(function(e){ io.observe(e); });
})();

/* ---------- preloader ---------- */
var pre = document.getElementById('pre');
var preCount = document.getElementById('preCount');
var preBar = document.getElementById('preBar');
var heroIntroPlayed = false;

function heroIntro(){
  if (heroIntroPlayed) return; heroIntroPlayed = true;
  var title = document.getElementById('heroTitle');
  var chars = title.querySelectorAll('img');
  if (hasGsap && !reduced){
    gsap.to(chars, {opacity:1, y:0, duration:1.4, ease:'power3.out', delay:.1});
    gsap.to('#heroSub', {opacity:1, duration:1.2, delay:.9, ease:'power2.out'});
    gsap.to('#heroJp', {opacity:1, duration:1.2, delay:1.15, ease:'power2.out'});
  } else {
    chars.forEach(function(c){c.style.opacity=1;c.style.transform='none'});
    document.getElementById('heroSub').style.opacity=1;
    document.getElementById('heroJp').style.opacity=1;
  }
}

/* ヒーローのロゴは正規ロゴ画像(白)。文字分割は廃止 */

(function(){
  if (reduced){ pre.classList.add('is-done'); heroIntro(); return; }
  /* 再訪(同セッション)はカウンターを省略して即座に開ける */
  var seen = false;
  try { seen = sessionStorage.getItem('tv8pre') === '1'; sessionStorage.setItem('tv8pre', '1'); } catch(e){}
  if (seen){
    preCount.textContent = '100';
    preBar.style.transform = 'scaleX(1)';
    setTimeout(function(){ pre.classList.add('is-done'); heroIntro(); }, 150);
    return;
  }
  var n = 0;
  var iv = setInterval(function(){
    n += Math.max(1, Math.round((100 - n) * .09));
    if (n >= 100){ n = 100; clearInterval(iv);
      setTimeout(function(){ pre.classList.add('is-done'); heroIntro(); }, 220);
    }
    preCount.textContent = (n<10?'0':'') + n;
    preBar.style.transform = 'scaleX(' + (n/100) + ')';
  }, 55);
  /* safety: never trap the page */
  setTimeout(function(){ pre.classList.add('is-done'); heroIntro(); }, 4200);
})();

/* ---------- lenis + scrolltrigger ---------- */
var lenis = null;
if (hasST) gsap.registerPlugin(ScrollTrigger);
if (!reduced && typeof Lenis !== 'undefined' && hasST){
  lenis = new Lenis({ duration: 1.15, smoothWheel: true });
  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add(function(t){ lenis.raf(t * 1000); });
  gsap.ticker.lagSmoothing(0);
}

/* ---------- UGC JS START ---------- */
(function(){
  var dialog = document.getElementById('ugcDialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  var frame = document.getElementById('ugcFrame');
  var original = document.getElementById('ugcOriginal');
  var product = document.getElementById('ugcProduct');
  var closeButton = dialog.querySelector('.ugc-dialog__close');
  var trigger = null;
  var previousOverflow = '';
  var previousBodyOverflow = '';
  var resumeLenis = false;
  var backdropPressed = false;

  document.querySelectorAll('[data-ugc-reel]').forEach(function(link){
    link.setAttribute('aria-haspopup', 'dialog');
    link.setAttribute('aria-controls', 'ugcDialog');
    link.addEventListener('click', function(event){
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var reel = link.getAttribute('data-ugc-reel');
      if (!/^[A-Za-z0-9_-]{11}$/.test(reel) || dialog.open) return;
      try { dialog.showModal(); } catch (error) { return; }
      event.preventDefault();
      trigger = link;
      previousOverflow = document.documentElement.style.overflow;
      previousBodyOverflow = document.body.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      resumeLenis = !!lenis && !lenis.isStopped;
      if (resumeLenis) lenis.stop();
      original.href = link.href;
      var card = link.closest('.ugc__card');
      var cardProduct = card && card.querySelector('.ugc__product');
      if (product) {
        product.replaceChildren();
        if (cardProduct) product.appendChild(cardProduct.cloneNode(true));
      }
      var iframe = document.createElement('iframe');
      iframe.title = link.getAttribute('aria-label') + ' — Instagram';
      iframe.src = 'https://www.instagram.com/reel/' + reel + '/embed/';
      iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      frame.replaceChildren(iframe);
      frame.scrollTop = 0;
      closeButton.focus({preventScroll:true});
    });
  });

  closeButton.addEventListener('click', function(){ dialog.close(); });
  dialog.addEventListener('pointerdown', function(event){
    var bounds = dialog.getBoundingClientRect();
    backdropPressed = event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom);
  });
  dialog.addEventListener('click', function(event){
    var bounds = dialog.getBoundingClientRect();
    if (backdropPressed && event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
    backdropPressed = false;
  });
  dialog.addEventListener('close', function(){
    frame.replaceChildren();
    if (product) product.replaceChildren();
    document.documentElement.style.overflow = previousOverflow;
    document.body.style.overflow = previousBodyOverflow;
    if (resumeLenis && lenis) lenis.start();
    resumeLenis = false;
    if (trigger && trigger.isConnected) trigger.focus({preventScroll:true});
    trigger = null;
  });
})();
/* ---------- UGC JS END ---------- */

/* anchor links through lenis */
document.querySelectorAll('a[href^="#"]').forEach(function(a){
  a.addEventListener('click', function(e){
    var id = a.getAttribute('href');
    var el = id.length > 1 ? document.querySelector(id) : document.body;
    if (!el) return;
    e.preventDefault();
    if (lenis) lenis.scrollTo(el, {offset:0, duration:1.4});
    else el.scrollIntoView({behavior:'smooth'});
  });
});

/* ---------- hero parallax ---------- */
if (hasST && !reduced){
  gsap.to('#heroMedia', {
    yPercent: 18, scale: 1.06, ease: 'none',
    scrollTrigger: {trigger:'#hero', start:'top top', end:'bottom top', scrub:true}
  });
  gsap.to('.hero__body', {
    yPercent: -30, opacity: .0, ease: 'none',
    scrollTrigger: {trigger:'#hero', start:'top top', end:'75% top', scrub:true}
  });
}

/* ---------- manifesto word reveal ---------- */
(function(){
  var el = document.getElementById('maniTxt');
  if (!el) return;
  var nodes = [];
  function splitNode(node){
    if (node.nodeType === 3){
      var frag = document.createDocumentFragment();
      /* keep latin word runs whole so "TRACE" never wraps mid-word */
      (node.textContent.match(/[A-Za-z0-9]+|[\s\S]/g) || []).forEach(function(tok){
        var s = document.createElement('span');
        s.className = 'wd'; s.textContent = tok;
        frag.appendChild(s); nodes.push(s);
      });
      node.parentNode.replaceChild(frag, node);
    } else if (node.nodeType === 1){
      Array.prototype.slice.call(node.childNodes).forEach(splitNode);
    }
  }
  Array.prototype.slice.call(el.childNodes).forEach(splitNode);
  if (hasST && !reduced){
    gsap.fromTo(nodes, {opacity:.35}, {
      opacity:1, stagger:.35, ease:'none',
      scrollTrigger:{trigger:el, start:'top 78%', end:'bottom 45%', scrub:true}
    });
  }
})();

/* ---------- baggage tags: 実写フィルム(タグが降り積もり、最後にTRACEが残る) ---------- */
(function(){
  var stage = document.getElementById('physStage');
  var film  = document.getElementById('physFilm');
  var btn   = document.getElementById('physReset');
  if (!stage || !film) return;

  /* 横長と正方形で別素材。両方DOMに置くと二重に落ちるので1本だけsrcを入れる */
  var sq = window.matchMedia('(max-width: 700px)');
  var loaded = '', visible = false, ended = false;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pick(){ return sq.matches ? 'sq' : 'wide'; }

  /* poster=1コマ目(空の床)。再生できないときだけ最終カット(タグの山)に差し替える */
  function poster(kind, which){
    film.setAttribute('poster', film.getAttribute('data-' + kind + '-' + which));
  }

  function apply(kind){
    if (loaded === kind) return;
    loaded = kind;
    if (reduced){ poster(kind, 'still'); return; }   /* 動きを減らす設定なら山の絵で止める */
    poster(kind, 'start');
    film.setAttribute('src', film.getAttribute('data-' + kind));
    film.load();
  }

  function play(){
    var kind = pick();
    apply(kind);
    if (reduced) return;
    ended = false;
    var p = film.play();
    /* 省電力モード等で自動再生が拒否されたら、意味の伝わる最終カットを出しておく */
    if (p && p.catch) p.catch(function(){ poster(kind, 'still'); });
  }

  /* 最後まで流れたら最終カットで止める。戻ってくるたびに勝手に流し直さない */
  film.addEventListener('ended', function(){ ended = true; });

  apply(pick());
  if (reduced && btn) btn.hidden = true;

  /* 幅が変わったら素材を差し替える(見えている間だけ再生し直す) */
  var onMQ = function(){
    var k = pick();
    if (k === loaded) return;
    film.removeAttribute('src');
    loaded = '';
    apply(k);
    if (visible) play();
  };
  if (sq.addEventListener) sq.addEventListener('change', onMQ);
  else if (sq.addListener) sq.addListener(onMQ);

  /* 画面に入ったら読み込んで再生、出たら止める(開きっぱなしでデコードし続けない) */
  if ('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(en){
      var e0 = en[en.length - 1];
      visible = e0.isIntersecting;
      if (visible && !ended && e0.intersectionRatio >= .25) play();
      else if (!visible && !film.paused) film.pause();
    }, {threshold: [0, .25]});
    io.observe(stage);
  } else {
    visible = true;
    play();
  }

  if (btn) btn.addEventListener('click', function(){
    if (reduced) return;
    apply(pick());
    try { film.currentTime = 0; } catch (e) {}
    play();
  });
})();

/* colorways: 3列グリッド化(2026-08-05)でピンスクラブ廃止 */

/* ---------- in-use video: scroll-scale + play in view ---------- */
(function(){
  var frame = document.getElementById('useFrame');
  var vid = document.getElementById('useVideo');
  if (!frame || !vid) return;
  if (hasST && !reduced){
    gsap.fromTo(frame, {scale: .64}, {
      scale: 1, ease: 'none',
      scrollTrigger: {trigger: '.use__stage', start: 'top 85%', end: 'top 12%', scrub: .5}
    });
  }
  if ('IntersectionObserver' in window && !reduced){
    var io = new IntersectionObserver(function(en){
      if (en[0].isIntersecting){ var p = vid.play(); if (p && p.catch) p.catch(function(){}); }
      else { vid.pause(); }
    }, {threshold: .2});
    io.observe(frame);
  }
})();

/* ---------- gallery ---------- */
(function(){
  var rail = document.getElementById('journeyRail');
  if (!rail) return;
  var gallery = document.getElementById('gallery');
  var nav = gallery.querySelector('.gal__nav');
  var prev = gallery.querySelector('[data-journey-prev]');
  var next = gallery.querySelector('[data-journey-next]');
  function update(){
    prev.disabled = rail.scrollLeft <= 2;
    next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
  }
  function step(){
    return rail.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(rail).columnGap) || 0);
  }
  function move(direction){
    rail.scrollBy({left: direction * step(), behavior: reduced ? 'auto' : 'smooth'});
  }
  nav.hidden = false;
  prev.addEventListener('click', function(){ move(-1); });
  next.addEventListener('click', function(){ move(1); });
  rail.addEventListener('scroll', update, {passive:true});
  window.addEventListener('resize', update);
  rail.addEventListener('keydown', function(e){
    if (e.target !== rail) return;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowRight'){
      e.preventDefault(); move(e.key === 'ArrowLeft' ? -1 : 1);
    } else if (e.key === 'Home' || e.key === 'End'){
      e.preventDefault(); rail.scrollTo({left:e.key === 'Home' ? 0 : rail.scrollWidth, behavior:reduced ? 'auto' : 'smooth'});
    }
  });
  var pointer = null, startX = 0, startY = 0, startScroll = 0, dragged = false;
  rail.addEventListener('pointerdown', function(e){
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    pointer = e.pointerId; startX = e.clientX; startY = e.clientY; startScroll = rail.scrollLeft; dragged = false;
  });
  rail.addEventListener('pointermove', function(e){
    if (pointer !== e.pointerId) return;
    var dx = e.clientX - startX;
    if (!dragged && Math.abs(dx) <= 6) return;
    if (!dragged && Math.abs(e.clientY - startY) > Math.abs(dx)){ pointer = null; return; }
    if (!dragged){ dragged = true; rail.setPointerCapture(e.pointerId); rail.classList.add('is-dragging'); }
    e.preventDefault(); rail.scrollLeft = startScroll - dx;
  });
  function finish(e){
    if (pointer !== e.pointerId) return;
    pointer = null; rail.classList.remove('is-dragging');
    if (rail.hasPointerCapture(e.pointerId)) rail.releasePointerCapture(e.pointerId);
  }
  rail.addEventListener('pointerup', finish);
  rail.addEventListener('pointercancel', finish);
  rail.addEventListener('pointerleave', function(e){ if (!dragged) finish(e); });
  rail.addEventListener('dragstart', function(e){ e.preventDefault(); });
  rail.addEventListener('click', function(e){ if (dragged && e.detail){ e.preventDefault(); e.stopPropagation(); } }, true);
  update();
  if (hasST && !reduced){
    gsap.matchMedia().add('(min-width: 701px)', function(){
      rail.querySelectorAll('.gal__col').forEach(function(col, index){
        var speed = [0,-40,-90][index % 3];
        if (speed) gsap.to(col, {y:speed, ease:'none', scrollTrigger:{trigger:'#gallery', start:'top bottom', end:'bottom top', scrub:true}});
      });
    });
  }
})();

/* ---------- marquee ---------- */
(function(){
  var track = document.getElementById('mqTrack');
  var unit = '<span class="mq__unit"><em>Every journey</em> leaves a trace<span class="dot"></span><span class="jp">旅の軌跡</span><span class="dot"></span></span>';
  track.innerHTML = unit + unit + unit + unit;
  if (!hasGsap || reduced) return;
  var x = 0, vel = 0;
  if (lenis){ lenis.on('scroll', function(e){ vel = e.velocity || 0; }); }
  var unitW = 0;
  function measure(){ unitW = track.children[0].getBoundingClientRect().width; }
  measure(); window.addEventListener('resize', measure);
  gsap.ticker.add(function(){
    var base = .9;
    x -= base + Math.min(Math.abs(vel) * .28, 6);
    if (unitW && -x >= unitW) x += unitW;
    track.style.transform = 'translateX(' + x + 'px)';
    var sk = Math.max(-6, Math.min(6, vel * .4));
    track.style.transform += ' skewX(' + sk + 'deg)';
    vel *= .94;
  });
})();

/* ---------- magnetic button ---------- */
if (fine){
  document.querySelectorAll('.fin__btn, .phys__btn').forEach(function(btn){
    var qx, qy;
    if (hasGsap){
      qx = gsap.quickTo(btn, 'x', {duration: .4, ease: 'power3'});
      qy = gsap.quickTo(btn, 'y', {duration: .4, ease: 'power3'});
    }
    btn.addEventListener('mousemove', function(e){
      var r = btn.getBoundingClientRect();
      var dx = e.clientX - (r.left + r.width / 2);
      var dy = e.clientY - (r.top + r.height / 2);
      if (qx){ qx(dx * .25); qy(dy * .35); }
    });
    btn.addEventListener('mouseleave', function(){ if (qx){ qx(0); qy(0); } });
  });
}

/* ---------- custom cursor ---------- */
if (fine){
  var cur = document.querySelector('.cur');
  var dot = cur.querySelector('.cur__dot');
  var ring = cur.querySelector('.cur__ring');
  var txt = cur.querySelector('.cur__txt');
  var mx = -100, my = -100, rx = -100, ry = -100;
  window.addEventListener('mousemove', function(e){ mx = e.clientX; my = e.clientY; });
  (function loop(){
    rx += (mx - rx) * .16; ry += (my - ry) * .16;
    dot.style.left = mx + 'px'; dot.style.top = my + 'px';
    ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
    requestAnimationFrame(loop);
  })();
  document.querySelectorAll('[data-cursor]').forEach(function(el){
    el.addEventListener('mouseenter', function(){
      cur.classList.add('is-zoom'); txt.textContent = el.getAttribute('data-cursor');
    });
    el.addEventListener('mouseleave', function(){ cur.classList.remove('is-zoom'); });
  });
}
})();